import ProviderServiceContent from "../content/providerServiceContent";
import Layout from "../layout/Layout";

const ProviderService = () => {
  return (
    <Layout>
      <ProviderServiceContent />
    </Layout>
  );
};

export default ProviderService;
